import React from "react";
import publicConfig from "../common/public-config";
const LinkGenerator = props => {
  var _publicConfig$directL;
  const NextLink = require("next/link").default;
  const {
    href
  } = props;
  const isBlackListed = href && (publicConfig === null || publicConfig === void 0 ? void 0 : (_publicConfig$directL = publicConfig.directLinks) === null || _publicConfig$directL === void 0 ? void 0 : _publicConfig$directL.find(blockedPath => href.includes(blockedPath)));
  return !isBlackListed && !!NextLink ? /*#__PURE__*/React.createElement(NextLink, props) : /*#__PURE__*/React.createElement("a", props, props.children);
};
export default LinkGenerator;